import React, {Component, useEffect, useState} from 'react';
import './styles.scss';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../../util/strings';
import ModalTemplate from '../../../../components/modal';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import AppButton from '../../../../components/app-button';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import {useMediaQuery} from 'react-responsive';

interface AppointmentsScheduleCapPopupProps {
  show: boolean;
  setShowModal(value: any): void;
  labels: typeof strings.pt.appointments;
}

function AppointmentsScheduleCapPopup({
  show,
  setShowModal,
  labels,
}: AppointmentsScheduleCapPopupProps) {
  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  return (
    <ModalTemplate
      className="appointment-limit-container"
      contentClassName="appointment-cancel-content"
      show={show}
      onHide={() => {
        setShowModal(false);
      }}
      cross={true}
      hideFooter={true}
      size="sm">
      <div className="modal-appointment-limit-container">
        <Row className="limit-error-title-row">
          <p
            style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
            className="p-myProfilePopup">
            {labels?.appointments_schedule_limit_error_title}
          </p>
        </Row>
        <Row className="my-profile-submit-button-row">
          <Icon
            name={Icons.ALERT_PROBLEM}
            width={'31'}
            height={'31'}
            color={colors.alertRed}
            changeViewbox
            viewBox={'0 0 24 24'}
          />
        </Row>
        <Row className="errorPopup-title-row">
          <p
            style={
              isResponsive
                ? {...fonts.M, ...fonts.Bold, color: colors.alertRed}
                : {...fonts.MM, ...fonts.Bold, color: colors.alertRed}
            }
            className="p-errorPopup">
            {`${labels?.appointments_schedule_limit_error1} ${labels?.appointments_schedule_upcoming_limit_default} ${labels?.appointments_schedule_limit_error2}`}
          </p>
        </Row>
        <div className="limit-error-description">
          <p
            style={
              isResponsive
                ? {...fonts.M, ...fonts.Light}
                : {...fonts.MM, ...fonts.Light}
            }
            className="p-errorPopup">
            {`${labels?.appointments_schedule_limit_error3} `}
          </p>
        </div>
        <Row className="my-profile-submit-button-row">
          <AppButton
            title="Ok"
            className="limit-error-button"
            variant="inverted"
            onClick={() => {
              setShowModal(false);
            }}>
            {labels?.appointments_understood}
          </AppButton>
        </Row>
      </div>
    </ModalTemplate>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.appointments,
  labelsPermissions: strings.value.pt.permissions,
});

export default compose(connect(mapStateToProps)(AppointmentsScheduleCapPopup));
